import React from 'react'
import WithdrawMoney from '../../components/Fundraiser/Withdraw';

const Withdraw = () => {
  return (
    <WithdrawMoney />
  )
}

export default Withdraw;